import {
  DefaultEffects,
  IComboBox,
  IComboBoxOption,
  Panel,
  PanelType,
  TextField,
} from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { ComboBoxIDS } from "../../../components/generic/ComboBoxIDS";
import { useComboTipoEquipo } from "../../../hooks/combosHooks/useComboTipoEquipo";
import {
  IPostCrearModeloEquipo,
  initialPostCrearModeloEquipo,
} from "../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import { useEquipoModeloCrear } from "../../../hooks/EquiposModelos/useEquipoModeloCrear";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";

interface IPanelAddModeloEquipo {
  isOpen: boolean;
  onDismiss: () => void;
  onRefreshTable: () => void;
}

export const PanelAddModeloEquipo = (props: IPanelAddModeloEquipo) => {
  const [requestCrearEquipoModelo, setRequestCrearEquipoModelo] =
    useState<IPostCrearModeloEquipo>(initialPostCrearModeloEquipo);

  const { ocultarMensaje, response, isSend, postCrearEquipoModelo } =
    useEquipoModeloCrear();

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="add"
          textHeader={`Modelo Equipo`}
          subTextHeader={`Agregar Modelo de Equipo`}
        />
      </>
    ),
    []
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Agregar"
          onClick={() => {
            postCrearEquipoModelo(requestCrearEquipoModelo);
          }}
          onDismiss={() => {
            props.onDismiss();
          }}
        />
      </>
    ),
    [postCrearEquipoModelo, requestCrearEquipoModelo]
  );

  const {
    dataComboTipoEquipos,
    onClickComboTipoEquipo,
    _onkeyUpSearchTipoEquipo,
    comboBoxRefTipoEquipo,
  } = useComboTipoEquipo();

  const onChangeCombo = (
    e: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    nombreCombo?: string
  ) => {
    if (e !== undefined) {
      if (option) {
        switch (nombreCombo) {
          case "tipoEquipo":
            setRequestCrearEquipoModelo({
              ...requestCrearEquipoModelo,
              tipoEquipoId: option.key.toString(),
            });
            break;

          default:
            break;
        }
      }
    }
  };
  const onChangeTextField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    valor?: string
  ) => {
    if (event !== undefined && valor !== undefined) {
      setRequestCrearEquipoModelo({
        ...requestCrearEquipoModelo,
        nombreModelo: valor,
      });
    }
  };

  useEffect(() => {
    if (!props.isOpen) {
      ocultarMensaje();
      props.onRefreshTable();
      setRequestCrearEquipoModelo(initialPostCrearModeloEquipo);
    }
  }, [props.isOpen]);

  return (
    <>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeader}
        onRenderFooter={onRenderFooter}
        isFooterAtBottom
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <>
          <MensajeBar
            response={response}
            ocultar={() => {
              ocultarMensaje();
            }}
          />
          {isSend == true ? (
            <IdicadorProgress isSend={isSend} subText="Espere un momento..." />
          ) : (
            <div className="ms-Grid" dir="ltr">
              <div
                style={{
                  margin: "30px 0px",
                  width: "100%",
                  height: "auto",
                  padding: "15px 0px",
                }}
              >
                <div
                  className="ms-Grid-row"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "end",
                  }}
                >
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <ComboBoxIDS
                      title="Tipo Equipo:"
                      componentRef={comboBoxRefTipoEquipo}
                      KeyUp={_onkeyUpSearchTipoEquipo}
                      onClick={onClickComboTipoEquipo}
                      options={dataComboTipoEquipos}
                      onChange={(e, option) => {
                        onChangeCombo(e, option, "tipoEquipo");
                      }}
                    />
                  </div>
                </div>
                <br />
                <br />
                <div
                  className="ms-Grid-row"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "end",
                  }}
                >
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <TextField
                      label="Modelo Equipo:"
                      onChange={(evento, valor) =>
                        onChangeTextField(evento, valor)
                      }
                      underlined
                      required
                      placeholder="Escribir aquí el nombre del modelo"
                    />
                  </div>
                </div>
                <br />
              </div>
            </div>
          )}
        </>
      </Panel>
    </>
  );
};
